const enterpriseSwiper = new Swiper('.company-overview__enterprise-swiper', {
    width: gvr_winW - 60,
    spaceBetween: 20,
    slideActiveClass: 'is-active',

    //effect: 'fade',
    scrollbar: {
        el: '.company-overview__enterprise-swiper-scrollbar',
        draggable: false,
    },
    pagination: {
        el: '.company-overview__enterprise-swiper-pagination',
        type: 'fraction',
        formatFractionCurrent: function (number) {
            number = String(number);
            if (number.length < 2) number = '0' + number;
            return number;
        },
        formatFractionTotal: function (number) {
            number = String(number);
            if (number.length < 2) number = '0' + number;
            return number;
        },
    },
});

let overviewCounter = [];
let overviewCounterNum = [];
let overviewCounterID = [];
let overview = {
    init: function () {
        $('.company-overview__statics-info dd')
            .each(function (i) {
                if ($(this).find('.counter').length) {
                    $(this)
                        .find('.counter')
                        .attr('id', 'number0' + i);
                    overviewCounterID[i] = $(this).find('.counter').attr('id');
                    overviewCounterNum[i] = $(this).find('.counter').text();
                }
            })
            .promise()
            .done(function () {
                overviewCounterID.forEach(function (item, index, array) {
                    let id = String(item);
                    let endNum = Number(overviewCounterNum[index]);
                    overviewCounter[index] = new CountUp(id, 0, endNum);
                });
            });
    },
    start: function () {
        overviewCounter.forEach(function (item, idx) {
            overviewCounter[idx].start();
        });
    },
    scroll: function (st) {
        const $companyStaticsInfo = $('.company-overview__statics-info');
        if ($companyStaticsInfo.length) {
            let companyStaticsInfoH = $companyStaticsInfo.outerHeight();
            let companyStaticsInfoTop = $companyStaticsInfo.offset().top;
            if (
                st >=
                companyStaticsInfoTop - gvr_winH + companyStaticsInfoH * 0.66
            ) {
                $companyStaticsInfo.addClass('is-active');
                this.start();
            }
        }
    },
};
overview.init();

$('.lx_tab--pr-movie').on('click', 'button', function () {
    let id = $(this).attr('id');
    $(this)
        .parent('.lx_tab--pr-movie')
        .siblings('.lx_tab-pannel')
        .attr('hidden', true);
    $(this)
        .parent('.lx_tab--pr-movie')
        .siblings('.lx_tab-pannel[aria-labelledby=' + id + ']')
        .attr('hidden', false);
});

let globalNetworkCounter = [];
let globalNetworkCounterNum = [];
let globalNetworkCounterID = [];
let globalNetwork = {
    init: function () {
        $('.global-branch-tit .counter')
            .each(function (i) {
                $(this).attr('id', 'number0' + i);
                globalNetworkCounterID[i] = $(this).attr('id');
                globalNetworkCounterNum[i] = $(this).text();
            })
            .promise()
            .done(function () {
                globalNetworkCounterID.forEach(function (item, index, array) {
                    let id = String(item);
                    let endNum = Number(globalNetworkCounterNum[index]);
                    globalNetworkCounter[index] = new CountUp(id, 0, endNum);
                });
            });
    },
    start: function () {
        globalNetworkCounter.forEach(function (item, idx) {
            globalNetworkCounter[idx].start();
        });
    },
    scroll: function (st) {
        //const $globalBranch = $('.global-branch');
        const $globalBranch = $('.global-branch-tit');
        if ($globalBranch.length) {
            let globalBranchH = $globalBranch.outerHeight();
            let globalBranchTop = $globalBranch.offset().top;
            if (st >= globalBranchTop - gvr_winH + globalBranchH) {
                this.start();
            }
        }
    },
};
globalNetwork.init();

if ($('.global-branch').length) {
    $(document)
        .on('click', '.global-branch li> button', function () {
            $(this)
                .addClass('is-active')
                .parent('li')
                .siblings('li')
                .children('button')
                .removeClass('is-active');
        })
        .on('click', '.global-branch .btn-close-layered', function () {
            $(this).parents('li').find('button').removeClass('is-active');
        });
}

$(window)
    .on('load', function () {
        overview.scroll(gvr_st);
        globalNetwork.scroll(gvr_st);
    })
    .on('scroll', function () {
        overview.scroll(gvr_st);
        globalNetwork.scroll(gvr_st);
    });
